module.exports = __webpack_public_path__ + "img/copy.fcc88854.png";